// src/Views/GlobalBackground.js

import React, { useEffect, useState } from 'react';
import { GrainGradient } from '@paper-design/shaders-react';
// Mouse following disabled for comparison:
// import React, { useEffect, useRef } from 'react';
import './GlobalBackground.css';

const useMediaQuery = (query) => {
  const getMatches = () => (
    typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia(query).matches
  );

  const [matches, setMatches] = useState(getMatches);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;

    const mediaQuery = window.matchMedia(query);
    const updateMatches = (event) => setMatches(event.matches);
    setMatches(mediaQuery.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', updateMatches);
      return () => mediaQuery.removeEventListener('change', updateMatches);
    }

    mediaQuery.addListener(updateMatches);
    return () => mediaQuery.removeListener(updateMatches);
  }, [query]);

  return matches;
};


const GlobalBackground = ({ theme, retroMode }) => {
  const isPhone = useMediaQuery('(max-width: 768px)');
  const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

  /* Mouse following disabled for comparison.
  const bgRef = useRef(null);

  const targetRef = useRef({ x: 0, y: 0 });
  const currentRef = useRef({ x: 0, y: 0 });

  const rafRef = useRef(null);

  useEffect(() => {
    const element = bgRef.current;

    if (!element) return;

    const animate = () => {
      currentRef.current.x +=
        (targetRef.current.x - currentRef.current.x) * 0.08;

      currentRef.current.y +=
        (targetRef.current.y - currentRef.current.y) * 0.08;

      element.style.setProperty(
        '--mouse-x',
        `${currentRef.current.x}px`
      );

      element.style.setProperty(
        '--mouse-y',
        `${currentRef.current.y}px`
      );

      const distanceX = Math.abs(targetRef.current.x - currentRef.current.x);
      const distanceY = Math.abs(targetRef.current.y - currentRef.current.y);

      if (distanceX > 0.1 || distanceY > 0.1) {
        rafRef.current = requestAnimationFrame(animate);
      } else {
        currentRef.current = { ...targetRef.current };
        rafRef.current = null;
      }
    };

    const handleMouseMove = (event) => {
      const x = (event.clientX / window.innerWidth - 0.5) * 2;

      const y = (event.clientY / window.innerHeight - 0.5) * 2;

      targetRef.current = {
        x: x * 700,
        y: y * 700,
      };

      if (rafRef.current === null) {
        rafRef.current = requestAnimationFrame(animate);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);

      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, []);
  */

return (
  <div className="global-bg">
    {/* Mouse following disabled: ref={bgRef} */}
    <GrainGradient
      className="global-bg__shader"
      width="100%"
      height="100%"
      colors={theme === 'light'
        ? ["#f9f7f2", "#c9cdd6", "#c8d9f0", "#ded4f2"]
        : ["#3f008c", "#29007d", "#000752"]}
      colorBack={theme === 'light' ? "#edf0f4" : "#000728"}
      softness={theme === 'light' ? 0.32 : 0.2}
      intensity={theme === 'light' ? 0.78 : 0.66}
      noise={theme === 'light' ? 0.2 : 0.25}
      shape="corners"
      speed={prefersReducedMotion ? 0 : (retroMode ? 0.18 : (theme === 'light' ? 1.32 : 1.04))}
      scale={theme === 'light' ? 1.55 : 1.8}
      rotation={104}
      offsetX={-0.92}
      offsetY={-0.62}
      maxPixelCount={isPhone ? 720000 : 2073600}
    />

    {/* Original background preserved for comparison:
    <span className="global-bg__flow" />
    <span className="global-bg__flow global-bg__flow--secondary" />
    */}
  </div>
);
};

export default GlobalBackground;
